angular.module('services')
.factory('sessionSrv', [function() {

}]);
